import { useState } from 'react';

export function useDialog(initialValue = false) {
  const [isOpen, setIsOpen] = useState(initialValue);

  return {
    onClose: () => setIsOpen(false),
    open: () => setIsOpen(true),
    isOpen,
  };
}
